import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

export const setPlatform = (platformId: PLATFORM_TYPES) => ({
    type: 'SET_PLATFORM' as const,
    payload: platformId
});
